export default __webpack_public_path__ + "static/media/p2p-icon.7130e6f2.svg";